// extracted by mini-css-extract-plugin
export default {"tabsStyle":"index-styles_tabsStyle__MZojN"};